// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/bigdata.css
// module id = 2651
// module chunks = 2